




import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";

interface ComboItem {
  text: string;
  value: boolean | null;
}

@Component
export default class ComboMidia extends Vue {
  itemsTipo: ComboItem[] = [
    {
      text: "",
      value: null,
    },
    {
      text: "Sim",
      value: true,
    },
    {
      text: "Não",
      value: false,
    },
  ];
  tipo: ComboItem | null = null;

  @Watch("tipo")
  onChangeTipo(val: ComboItem) {
    this.$emit("input", val?.value);
  }
}
